<template>
  <el-col :span="24">
    <div
      class="ma-0"
      v-loading="loading"
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
    <div class="custom-table-design">
      <el-table
        :data="visibleRows"
        :fit="true"
        height="650"
        stripe
        row-key="id"
        :span-method="spanRegionColumn"
        :row-class-name="tableRowClassName"
        @row-click="handleRowClick"
        class="my-2 data-table"
        scrollbar-always-on: false
      >
        <el-table-column
          :label="'Region'"
          :prop="'region_name'"
          :width="$vuetify.display.width <= 1200 ? 220 : ''"
        >
          <template #default="scope">
            <div
              class="d-flex align-items-center"
              :class="{
                'history-toggle':
                  scope.row._isLatest && scope.row._historyCount > 0,
              }"
              @click.stop="toggleRegionFromRow(scope.row)"
            >
              <i
                v-if="scope.row._isLatest && scope.row._historyCount > 0"
                :class="
                  isRegionExpanded(scope.row.region_name)
                    ? 'fa fa-caret-down mr-2'
                    : 'fa fa-caret-right mr-2'
                "
                :title="
                  isRegionExpanded(scope.row.region_name)
                    ? 'Hide history'
                    : 'Show history'
                "
              ></i>
              <span v-if="scope.row._isLatest">
                {{ scope.row.region_name }}
                <span
                  v-if="scope.row._historyCount > 0 && !isRegionExpanded(scope.row.region_name)"
                  class="history-count"
                >
                  ({{ scope.row._historyCount }} older)
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="'Name'"
          :prop="'name'"
          :width="$vuetify.display.width <= 1200 ? 160 : ''"
        >
          <template #default="scope">
            {{ formatRangeName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Effective from'"
          :prop="'start_date'"
          :width="$vuetify.display.width <= 1200 ? 180 : ''"
        >
          <template #default="scope">
            {{ formatEffectiveDate(scope.row.start_date) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Effective till'"
          :prop="'end_date'"
          :width="$vuetify.display.width <= 1200 ? 180 : ''"
        >
          <template #default="scope">
            {{ formatEffectiveTill(scope.row.end_date) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Factor'"
          :prop="'factor'"
          :width="$vuetify.display.width <= 1200 ? 160 : ''"
        />

        <el-table-column
          v-if="
            $vuetify.display.width < 500 &&
            $store.state.auth.user != null &&
            !$store.state.auth.user.is_auditor
          "
          :label="'Actions'"
          :prop="'operations'"
          align="center"
          width="150"
        >
          <template #default="scope">
            <el-tooltip placement="top" effect="light">
              <template #content>Update</template>
              <el-button
                v-if="
                  scope.row.id != null && scope.row.id != ''
                "
                @click.stop="handleShow(scope.$index, scope.row)"
                size="small"
                class="height-25  rounded-2 m-0 ml-2"
                color="#DDF0AC"
                style="width: 25px; height: 25px; padding: 0px; align-items: center;"
              >
                  <svg style="width: 24px; height: 24px;">
                      <use href="@/assets/svg/newSvgIcon.svg#tableOperationEdit"></use>
                  </svg>
              </el-button>
            </el-tooltip>

            <el-tooltip placement="top" effect="light">
              <template #content>Delete</template>
              <el-button
                v-if="
                  scope.row.id != null && scope.row.id != ''
                "
                @click.stop="deleteRow(scope.row, scope.$index)"
                size="small"
                class="height-25  rounded-2 m-0 ml-2"
                color="#DDF0AC"
                style="width: 25px; height: 25px; padding: 0px; align-items: center;"
              >
                  <svg style="width: 24px; height: 24px;">
                      <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                  </svg>
              </el-button>
            </el-tooltip>

            <el-tooltip placement="top" effect="light">
              <template #content>New version</template>
              <el-button
                v-if="
                  scope.row.id != null && scope.row.id != ''
                "
                @click.stop="copyRow(scope.row, scope.$index)"
                size="small"
                class="height-25  rounded-2 m-0 ml-2"
                color="#DDF0AC"
                style="width: 25px; height: 25px; padding: 0px; align-items: center;"
              >
                  <svg style="width: 24px; height: 24px;">
                      <use href="@/assets/svg/newSvgIcon.svg#make-a-copy-btn"></use>
                  </svg>
              </el-button>
            </el-tooltip>

          </template>
        </el-table-column>
        <el-table-column
          v-else-if="
            $store.state.auth.user != null && !$store.state.auth.user.is_auditor
          "
          fixed="right"
          :label="'Actions'"
          :prop="'operations'"
          align="center"
          width="150"
        >
          <template #default="scope">
            <el-tooltip placement="top" effect="light">
              <template #content>Update</template>
              <el-button
                v-if="
                  scope.row.id != null && scope.row.id != ''
                "
                @click.stop="handleShow(scope.$index, scope.row)"
                size="small"
                class="height-25 rounded-2 m-0 ml-2"
                color="#DDF0AC"
                style="width: 25px; height: 25px; padding: 0px; align-items: center;"
              >
                  <svg style="width: 24px; height: 24px;">
                      <use href="@/assets/svg/newSvgIcon.svg#tableOperationEdit"></use>
                  </svg>
              </el-button>
            </el-tooltip>

            <el-tooltip placement="top" effect="light">
              <template #content>Delete</template>
              <el-button
                v-if="
                  scope.row.id != null && scope.row.id != ''
                "
                @click.stop="deleteRow(scope.row, scope.$index)"
                size="small"
                class="height-25 rounded-2 m-0 ml-2"
                color="#DDF0AC"
                style="width: 25px; height: 25px; padding: 0px; align-items: center;"
              >
                  <svg style="width: 24px; height: 24px;">
                      <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                  </svg>
              </el-button>
            </el-tooltip>

            <el-tooltip placement="top" effect="light">
              <template #content>New version</template>
              <el-button
                v-if="
                  scope.row.id != null && scope.row.id != ''
                "
                @click.stop="copyRow(scope.row, scope.$index)"
                size="small"
                class="height-25 rounded-2 m-0 ml-2"
                color="#DDF0AC"
                style="width: 25px; height: 25px; padding: 0px; align-items: center;"
              >
                  <svg style="width: 24px; height: 24px;">
                      <use href="@/assets/svg/newSvgIcon.svg#make-a-copy-btn"></use>
                  </svg>
              </el-button>
            </el-tooltip>


          </template>
        </el-table-column>
      </el-table>
    </div>

      <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
        <el-row class="row-bg" justify="space-between">
          <el-col
            :span="5"
            class="d-flex justify-content-start align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col
            :span="8"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col :span="5" class="d-flex justify-content-end align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>

      <div class="custom-pagination" v-if="$vuetify.display.width < 700">
        <el-row class="row-bg" justify="space-between">
          <el-col
            :span="24"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col
            :span="10"
            class="d-flex justify-content-end align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>

          <el-col :span="10" class="d-flex justify-content-start align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>

    </div>
  </el-col>
</template>

<script>
export default {
  props: {
    loadingProp: {
      type: Boolean,
      default: false,
    },
    emissionIntensityDataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
    totalRowProp: {
      type: Number,
    },
  },
  data() {
    return {
      show: true,
      emissionIntensityList: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
      expandedRegions: {},
    };
  },
  watch: {
    loadingProp: {
      handler: function (newValue) {
        this.loading = newValue;
      },
      deep: true,
    },
    emissionIntensityDataProp: {
      handler: function (newValue) {
        this.emissionIntensityList = newValue;
      },
      deep: true,
    },
    totalRowProp: {
      handler: function (newValue) {
        this.current_page = 1;
        this.total_items = newValue;
        console.log(this.total_items);
      },
      deep: true,
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      this.$emit("tableAction", {
        index: this.page_size,
        data: null,
        kind: "perPageChange",
      });
    },

  },
  computed: {
    visibleRows() {
      const rows = [];
      const list = this.emissionIntensityList || [];
      let i = 0;
      while (i < list.length) {
        const regionName = list[i].region_name;
        let j = i + 1;
        while (j < list.length && list[j].region_name === regionName) {
          j += 1;
        }
        const versions = list.slice(i, j);
        rows.push({
          ...versions[0],
          _isLatest: true,
          _historyCount: versions.length - 1,
        });
        if (this.expandedRegions[regionName]) {
          for (let k = 1; k < versions.length; k++) {
            rows.push({
              ...versions[k],
              _isLatest: false,
              _historyCount: 0,
            });
          }
        }
        i = j;
      }
      return rows;
    },
  },
  methods: {
    tableRowClassName({ row }) {
      return row._isLatest === false ? "history-row" : "";
    },
    isRegionExpanded(regionName) {
      return !!this.expandedRegions[regionName];
    },
    toggleRegionFromRow(row) {
      if (!row?._isLatest || !row._historyCount) {
        return;
      }
      this.toggleRegion(row.region_name);
    },
    toggleRegion(regionName) {
      this.expandedRegions = {
        ...this.expandedRegions,
        [regionName]: !this.expandedRegions[regionName],
      };
    },
    formatRangeName(row) {
      const name = row?.name;
      if (name != null && String(name).trim() !== "") {
        return name;
      }
      return "—";
    },
    formatEffectiveDate(value) {
      if (value == null || value === "") {
        return "—";
      }
      const datePart = String(value).split("T")[0];
      const [year, month, day] = datePart.split("-");
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthLabel = months[Number(month) - 1];
      if (!year || !monthLabel || !day) {
        return datePart;
      }
      return `${day} ${monthLabel} ${year}`;
    },
    formatEffectiveTill(value) {
      if (value == null || value === "") {
        return "—";
      }
      return this.formatEffectiveDate(value);
    },
    spanRegionColumn({ column, rowIndex }) {
      if (column.property !== "region_name") {
        return [1, 1];
      }
      const data = this.visibleRows || [];
      const regionName = data[rowIndex]?.region_name;
      if (rowIndex > 0 && data[rowIndex - 1]?.region_name === regionName) {
        return [0, 0];
      }
      let rowspan = 1;
      for (let i = rowIndex + 1; i < data.length; i++) {
        if (data[i]?.region_name === regionName) {
          rowspan += 1;
        } else {
          break;
        }
      }
      return [rowspan, 1];
    },
    handleRowClick(row, column, event) {
      console.log(row, column, event);
    },
    handleShow(index, data) {
      this.$emit("tableAction", { index: index, data: data, kind: "edit" });
    },
    deleteRow(event, index) {
      this.$emit("tableAction", { index: index, data: event, kind: "delete" });
    },
    copyRow(event, index) {
      this.$emit("tableAction", { index: index, data: event, kind: "copy" });
    },
    changePage(page) {
      this.$emit("tableAction", {
        index: page,
        data: null,
        kind: "changePage",
      });
    },
  },
};
</script>

<style>
.history-toggle {
  cursor: pointer;
  user-select: none;
}
.history-count {
  margin-left: 6px;
  opacity: 0.75;
  font-size: 12px;
}
.el-table .history-row {
  opacity: 0.8;
}
</style>
